import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], total:0 , error: "", message: "" }


export const userProfilerAction = createAsyncThunk(
    'create-user-profiler',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/admins/api/get-user-profiler?publisher_id=${data?.publisher_id}&page=${data?.page}&limit=${data?.limit}&status=${data?.status}&startDate=${data?.startDate}&endDate=${data?.endDate}`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const createUserProfilerSlice = createSlice({
    name: 'publisher-user-detail',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(userProfilerAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(userProfilerAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.total = action?.payload?.total
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(userProfilerAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
                state.total = action?.payload?.total

            })
        },

})



export const userProfilerReducer = createUserProfilerSlice.reducer